import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>
					This Prior Authorization Number has expired. Please contact the ordering prescriber to determine the patient’s current need for this request. If you fill this prescription, the claim will not be paid, or the payment amount may be subject to recoupment. 
				</p>
			</div>
		);
	}
}